import { render, staticRenderFns } from "./ProductCardPreview.vue?vue&type=template&id=b440584c&scoped=true&"
import script from "./ProductCardPreview.vue?vue&type=script&lang=js&"
export * from "./ProductCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPreview.vue?vue&type=style&index=0&id=b440584c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b440584c",
  null
  
)

export default component.exports